import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../../../../core/services/AuthService.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Subscription, interval } from 'rxjs';
import { WebUserDetails } from '../../../../shared/models/WebUserDetails';
import { WebUserService } from '../../../../core/services/WebUser.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  isLoginError: boolean = false;
  errorMessage: string = '';
  loader: boolean = false;
  login: boolean = false;
  refreshSubscription: Subscription;
  webUserModel: WebUserDetails[];
  allUsers: WebUserDetails[];
  constructor(private authService: AuthServiceService,
    private router: Router,
    private webuserService: WebUserService
  ) { }

  ngOnInit() {


    let currentSessionId = JSON.parse(sessionStorage.getItem('Id'));
    this.allUsers = JSON.parse(localStorage.getItem('userDetails'));
    if (this.allUsers == undefined || this.allUsers == null) {
      sessionStorage.clear();
    }
    else if (currentSessionId != null && currentSessionId != undefined) {
      let index = this.allUsers.findIndex(i => i.id == currentSessionId);

      if (index != undefined && index != null && index != -1) {
        this.allUsers.splice(index, 1);
        localStorage.setItem('userDetails', JSON.stringify(this.allUsers));
      }
      sessionStorage.clear();
    }
    if (this.refreshSubscription != undefined) {
      this.refreshSubscription.unsubscribe();
    }

  }

  getApiData() {
    this.authService.testingApiData().subscribe((Data) => {
    });
  }

  onSubmit(username, password, panel) {
    this.login = true;
    this.loader = true;
    this.authService.userAuthentication(username, password, panel == "null" ? 1 : panel).subscribe((data: any) => {


      this.refreshSubscription = interval(86400000).subscribe(() => {
        this.authService.RefreshToken().subscribe();
      })
      sessionStorage.setItem('Id', JSON.stringify(data.Id));
      this.webUserModel = JSON.parse(localStorage.getItem('userDetails'));
      let userModel: WebUserDetails = new WebUserDetails();
      userModel.id = data.Id;
      userModel.userToken = data.access_token;
      userModel.userRole = data.role;
      userModel.refreshToken = data.refresh_token;
      if (this.webUserModel != undefined) {
        this.webUserModel.push(userModel);
      } else {
        this.webUserModel = [];
        this.webUserModel.push(userModel);
      }
      localStorage.setItem('userDetails', JSON.stringify(this.webUserModel));
      this.webuserService.updateUser(data.Id);
      let userRole = this.webUserModel.filter(i => i.id == data.Id)[0].userRole;

      if (userRole == 'SA') {
        this.router.navigate(['/SA/Home']);
      }
      else if (userRole == 'HA') {
        this.router.navigate(['/Hospital/HAAdmin']);
      }
      else if (userRole == 'UHA') {
        this.router.navigate(['/Hospital/HAAdmin']);
      }
      else if (userRole == 'EA') {
        localStorage.setItem('Memory', data.Memory);
        this.authService.getPermissionsData().subscribe((abc) => {
          this.router.navigate(['/Physician/MainHome']);
        })
      }
      else if (userRole == 'PA') {
        this.router.navigate(['/Patient/PAPanel']);
      }
      else if (userRole == 'REG') {
        sessionStorage.setItem('Email', data.Email);
        this.router.navigate(['/Register']);
      }
      else if (userRole == 'PAREG') {
        sessionStorage.setItem('PatientEmail', data.PatientEmail);
        this.router.navigate(['/PARegister']);
      }
    }, (err: HttpErrorResponse) => { this.loader = false; this.login = false; this.isLoginError = true; this.errorMessage = err.error["error_description"]; });
  }

}
